// extracted by mini-css-extract-plugin
export default {"switchInputOn":"Switch_switchInputOn__xD9+D","switchInputOff":"Switch_switchInputOff__j7YmR"};